import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'shared/components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  public openSnackBar(message: string,  type: any, duration: number = 2000): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: duration,
      panelClass: [type],
      data: { message, type},
    });
  }
}
